var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform-icon"},[(_vm.platformColor)?_c('BaseIcon',{staticClass:"platform-icon__icon",attrs:{"name":"square-filled","color":_vm.platformColor}}):_c('div',{staticClass:"platform-icon__fallback"},[_c('span',{staticClass:"platform-icon__fallback--icon"},[_vm._v("?")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }